import { TextView } from "nystem-components";

const TextareaView = (props) => <TextView {...props} />;
export default TextareaView;
